export default __webpack_public_path__ + "static/media/2-2-4.02443842.jpg";